module.exports = __webpack_public_path__ + "img/thumb.bf4ba3bf.png";